import { render, staticRenderFns } from "./WorkCard.vue?vue&type=template&id=220ab8b2&"
import script from "./WorkCard.vue?vue&type=script&lang=js&"
export * from "./WorkCard.vue?vue&type=script&lang=js&"
import style0 from "./WorkCard.vue?vue&type=style&index=0&id=220ab8b2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports